import React from 'react';

/**
 * ObliqueBadge - Status tag & pill component.
 * Used across QMS, CRM, and Analytics for status, tags, and metrics.
 */
export function Badge({
    children,
    variant = 'neutral', // 'neutral', 'success', 'warning', 'danger', 'info', 'accent'
    size = 'md', // 'sm', 'md'
    dot = false,
    className = '',
    ...props
}) {
    const variants = {
        success: 'bg-green-500/15 text-green-700 dark:text-green-400 border border-green-200 dark:border-green-800/50',
        warning: 'bg-amber-500/15 text-amber-700 dark:text-amber-400 border border-amber-200 dark:border-amber-800/50',
        danger: 'bg-red-500/15 text-red-700 dark:text-red-400 border border-red-200 dark:border-red-800/50',
        info: 'bg-blue-500/15 text-blue-700 dark:text-blue-400 border border-blue-200 dark:border-blue-800/50',
        accent: 'bg-primary/15 text-primary border border-primary/20',
        neutral: 'bg-muted text-muted-foreground border border-border/50'
    };

    const dotColors = {
        neutral: 'bg-[var(--text-tertiary)]',
        success: 'bg-[#10b981]',
        warning: 'bg-[#f59e0b]',
        danger: 'bg-[#ef4444]',
        info: 'bg-[#3b82f6]',
        accent: 'bg-[#6366f1]',
    };

    const sizes = {
        sm: 'px-2 py-0.5 text-[11px] font-medium rounded-md',
        md: 'px-2.5 py-1 text-[12px] font-medium rounded-lg',
    };

    const baseStyles = 'inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors';

    return (
        <span
            className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
            {...props}
        >
            {dot && (
                <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
            )}
            {children}
        </span>
    );
}
